import { type FC } from 'react'

import { ErxBonusLandingPageHero } from './ErxBonusLandingPageHero'
import { ErxBonusLandingPageHeroActions } from './ErxBonusLandingPageHeroActions'

export const ErxBonusLandingPageHeroHeader: FC = () => {
  return (
    <div className="bg-light-brand-high">
      <div className="m-auto flex max-w-5xl flex-col-reverse overflow-hidden tablet:flex-row desktop:gap-8">
        <ErxBonusLandingPageHeroActions />
        <ErxBonusLandingPageHero />
      </div>
    </div>
  )
}
